import { z } from 'zod';
import { parseOrThrow } from './validate';

const FactionFile = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  unitNames: z.record(z.string(), z.string()),
  buildingNames: z.record(z.string(), z.string()),
});

export type Faction = z.infer<typeof FactionFile>;

export function parseFaction(raw: unknown, source = 'faction file'): Faction {
  return parseOrThrow(FactionFile, raw, source);
}
